

export default {
    name: "ReportSubscriptionBanner",

    emits: ['open-modal'],

    data() {
        return {
            isOpened: false,
        }
    },

    methods: {
        openModal() {
            this.$emit('open-modal', true);
        },
    },
}
